import SettingsNotificationSimpleView from './SettingsNotificationSimpleView'
export default SettingsNotificationSimpleView
